export default function canInteractWithTaskInstance(taskInstance, user) {
  const { assigneeId, locationId } = taskInstance;
  const { id: userId } = user;

  return assigneeId === userId || user.canActOnLocation({ id: locationId });
}
